module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opened),
      expression: "opened"
    }],
    staticClass: "stage stage--full-size",
    attrs: {
      "data-stage": "7"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opened),
      expression: "opened"
    }],
    staticClass: "contents"
  }, [_c('div', {
    staticClass: "booking-summary booking-confirmation-summary"
  }, [_c('div', {
    staticClass: "booking-summary__block"
  }, [_c('div', {
    staticClass: "booking-summary__text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.header))]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.confirmationMsg) + "\n                    ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('table', [_c('tr', [_c('td', [_vm._v("Reference")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.confirmedBooking.reference))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Type")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.confirmedBooking.booking.type.name))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.confirmedBooking.booking.first_name) + " " + _vm._s(_vm.confirmedBooking.booking.last_name))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.confirmedBooking.booking.email))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Guests")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.confirmedBooking.pax) + " people")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Date")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DateService.friendlyDate(_vm.confirmedBooking.date)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.confirmedBooking.booking.time))])]), _vm._v(" "), (_vm.confirmedBooking.booking.offer) ? _c('tr', [_c('td', [_vm._v("Offer")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.confirmedBooking.booking.offer.title))])]) : _vm._e(), _vm._v(" "), (_vm.confirmedBooking.booking.notes !== '') ? _c('tr', [_c('td', [_vm._v("Notes")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.confirmedBooking.booking.notes))])]) : _vm._e(), _vm._v(" "), (_vm.confirmedBooking.hasCustomField) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.confirmedBooking.customFieldLabel))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.confirmedBooking.customFieldValue))])]) : _vm._e()]), _vm._v(" "), (_vm.shouldShowRewards) ? _c('div', {
    staticClass: "booking-summary-offers booking-summary-callout"
  }, [_c('strong', {
    staticClass: "callout-title"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 45 43",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('polygon', {
    attrs: {
      "id": "Star",
      "fill": "#D8D8D8",
      "points": "22.5 32.6649997 8.68704657 42.5118994 13.7835673 26.3321406 0.150171867 16.2381006 17.1129484 16.0853595 22.5 0 27.8870516 16.0853595 44.8498281 16.2381006 31.2164327 26.3321406 36.3129534 42.5118994"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("GOOD NEWS")])]), _vm._v(" "), _c('span', [_vm._v("You have earned "), _c('strong', [_vm._v(_vm._s(_vm.confirmedBooking.pointsEarned))]), _vm._v(" ("), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.confirmedBooking.pointsEarnedValue)
    }
  }), _vm._v(") points by making this booking.")])]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cd2d998","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/confirmationStage.vue
// module id = 604
// module chunks = 0